




import { IPropertyUpdate } from '@/typings/import';
import { Component, Prop, Vue, Watch,  } from "vue-property-decorator";
import PropertyUpdateHelper from './models/PropertyUpdateHelper';

@Component({
  components: {
  },
})
export default class PropertyUpdateRow extends Vue {
  isValid: boolean = true;
  @Prop({ required: true }) private propertyUpdate: IPropertyUpdate<any>;

  get cellClass() {
    switch (this.propertyUpdate.propertyName) {
      case 'destination':
      case 'secondaryDestination':
        const destinations = this.$store.state.destination.destinations;
        return this.propertyUpdate.isValid(destinations) ? '' : 'red';
      default:
        return this.propertyUpdate.isValid() ? '' : 'red';
    }
  }

  get propertyUpdateValue() {
    return PropertyUpdateHelper.getValue(this.propertyUpdate);
  }

}
